import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchConfig = () => api.get("/catalog/config").then((r) => r.data);
export const fetchCategories = () => api.get("/catalog/categories").then((r) => r.data);
export const fetchProducts = (params) => api.get("/catalog/products", { params }).then((r) => r.data);
export const fetchProduct = (slug) => api.get(`/catalog/products/${slug}`).then((r) => r.data);
export const searchProducts = (q) => api.get("/catalog/search", { params: { q } }).then((r) => r.data);
export const checkoutCart = (items, verification) =>
  api.post("/checkout", { items, ...(verification || {}) }).then((r) => r.data);
export const subscribeNewsletter = (email) => api.post("/newsletter", { email }).then((r) => r.data);
export const verificationStatus = (email) =>
  api.get("/verification/status", { params: { email } }).then((r) => r.data);

export const money = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n ?? 0);
